import { useEffect } from "react";
import { useState } from "react";
import toast from "react-hot-toast";
import InfiniteScroll from "react-infinite-scroll-component";
import { Link } from "react-router-dom";
import { DIAMONDS_COLLECTION } from "../../constants";
import db from "../../firebaseConfig";
import LoadingIndicator from "../layouts/LoadingIndicator";
import DiamondCard from "./DiamondCard";
import AlertDialog from "../layouts/AlertDialog";
import { connect } from "react-redux";
import { setHasMore, updateDiamonds, updateDiamondsFromCollections } from "../../redux/diamond/diamondActions";

const DiamondPage = ({ auth, diamond, updateDiamonds, updateDiamondsFromCollections }) => {
    const { diamonds, hasMore, lastDocId, loading } = diamond;
    const [alert, setAlert] = useState({ show: false, isloading: false, id: null });

    useEffect(() => {
        if(diamond.diamonds.length === 0){
            getData();
        }  
    }, []);

    const getData = async () => await db.collection(DIAMONDS_COLLECTION).orderBy('createdAt','asc').limit(5).get()
        .then((collections) => updateDiamondsFromCollections(collections));

    const fetchDiamonds = async () => {
        if(lastDocId && !loading) {
            return await db.collection(DIAMONDS_COLLECTION)
            .orderBy('createdAt','asc')
            .startAfter(lastDocId)
            .limit(5)
            .get()
            .then((collections) => updateDiamondsFromCollections(collections));
        }
    }

    const toggleStatus = async (diamond) => {
        if(auth.user.type !== 'super-admin') return;

        const uid = diamond.uid;
        await db.collection(DIAMONDS_COLLECTION).doc(uid).update({status: !diamond.status});
        let updatedData = diamonds.map((doc) => {
            if(doc.uid === uid) {
                doc.status = !doc.status;
                return  doc;
            } else return doc;
        });
        updateDiamonds(updatedData);
    }

    const toggleOnlyGameAccountId = async (uid, status = false) => {
        if(auth.user.type !== 'super-admin') return;

        await db.collection(DIAMONDS_COLLECTION).doc(uid).update({onlyGameAccountId: status});
        
        let updatedData = diamonds.map((diamond) => {
            if(diamond.uid!==uid) {
                return diamond;
            } else {
                diamond.onlyGameAccountId = status;
                return diamond;
            }
        });
        updateDiamonds(updatedData);
        toast.success('Success!', {position: 'bottom-center', className: 'backdrop-filter backdrop-blur-lg bg-opacity-20',id: 'clipboard',});
    }

    const handleDelete = async () => {
        if(auth.user.type !== 'super-admin') return;
        setAlert({ show: alert.show, isloading: true, id: alert.id });
        const uid = alert.id;
        await db.collection(DIAMONDS_COLLECTION).doc(uid).delete();
        let updatedData = diamonds.filter((diamond) => diamond.uid!==uid);
        updateDiamonds(updatedData);
        setAlert({ show: false, isloading: false, id: null });
    }

    return (
        <div className="min-h-screen">
            <div className="flex w-full justify-between bg-blue-400 py-4 px-4 backdrop-filter backdrop-blur-lg bg-opacity-20 overflow-hidden shadow">
                <p className="m-auto inset-0 text-xl font-semibold leading-7 text-center text-gray-200">Diamond Pricing</p>
                <Link to="/create-diamond" className="bg-indigo-200 rounded-md p-1 inline-flex items-center justify-center text-indigo-800 hover:text-gray-500 hover:bg-indigo-200 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500 backdrop-filter backdrop-blur-lg bg-opacity-20 hover:bg-opacity-20 overflow-hidden shadow-lg">
                    <svg viewBox="0 0 20 20" enableBackground="new 0 0 20 20" className="w-6 h-6 inline-block"
                    ><path fill="#FFFFFF" d="M16,10c0,0.553-0.048,1-0.601,1H11v4.399C11,15.951,10.553,16,10,16c-0.553,0-1-0.049-1-0.601V11H4.601C4.049,11,4,10.553,4,10c0-0.553,0.049-1,0.601-1H9V4.601C9,4.048,9.447,4,10,4c0.553,0,1,0.048,1,0.601V9h4.399C15.952,9,16,9.447,16,10z"/>
                    </svg>
                </Link>
            </div>
            <InfiniteScroll
                dataLength={diamonds.length} //This is important field to render the next data
                next={fetchDiamonds}
                hasMore={hasMore}
                style={{height: 'unset', overflow: 'unset'}}
                loader={<LoadingIndicator/>}
                endMessage={
                    <p className="text-gray-500 mt-2" style={{ textAlign: 'center' }}>
                    <b>Yay! You have seen it all</b>
                    </p>
                }
                >
                <div className="flex justify-center items-center mt-10">
                    <div className="space-y-10 w-full md:w-1/2 lg:w-1/2 px-4">
                        {diamonds.map((diamond, index) => {
                            return (
                                <DiamondCard
                                    diamond={diamond}
                                    toggleStatus={toggleStatus}
                                    toggleOnlyGameAccountId={toggleOnlyGameAccountId}
                                    setAlert={setAlert}
                                    key={index}
                                />
                            );
                        })}
                    </div>
                </div>
            </InfiniteScroll>
            <AlertDialog
                show={alert.show}
                isloading={alert.isloading}
                title="Confirm delete?"
                description="Are you sure want to delete this item. Confirm delete."
                ok="Confirm"
                handleCancel={() => setAlert({ show: false, isloading: false, id: null })}
                handleOk={handleDelete}
            />
        </div>
    );
}


const mapStateToProps = state => {
    return {
        auth: state.auth,
        diamond: state.diamond
    };
}


const mapDispatchToProps = dispatch => {
    return {
        updateDiamonds: (latestData) => dispatch(updateDiamonds(latestData)),
        updateDiamondsFromCollections: (collections) => dispatch(updateDiamondsFromCollections(collections)),
        setHasMore: (value) => dispatch(setHasMore(value))
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(DiamondPage);